import { Button, Paper, PaperBorderType } from '@roc/ui';
import { Add } from '@material-ui/icons';
import { Grid, makeStyles } from '@material-ui/core';
import { useGeneralTasksStore } from '@roc/feature-general-tasks';
import { EditTaskDialog } from 'libs/feature-general-tasks/src/generalTasks/components/editTask/editTaskDialog';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { AddDraw } from './actions/addDraw';
import { FreezeFunding } from './actions/freezeFunding';
import { AddDrawV2 } from './actions/addDrawV2';
import { useBaseStore } from '@roc/feature-app-core';
import { isPcConditionOpen, PostClosingConditionService } from 'libs/feature-documents/src/documents/services/documentForms/postClosingConditionService';

const useStyles = makeStyles(() => ({
  buttonsContainer: {
    padding: '0 16px 16px 16px'
  },
  button: {
    height: '30px',
    padding: '4px 14px',
    border: '1px solid #285391',
    color: '#285391',
    textTransform: 'none',
  },
}));

export const LoanActionButtons = observer(({ loanId }) => {
  const classes = useStyles();
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const { drawStore: { drawActionsStore } } = useDrawsStore();
  const { globalStore } = useBaseStore();
  const postClosingConditionService = new PostClosingConditionService();

  const handleAddDraw = async () => {
    try {
      const response = await postClosingConditionService.hasOpenConditions(loanId);
      const hasOpen = response?.data === true;
      if (hasOpen) {
        globalStore.notificationStore.showErrorNotification({
          message: 'Cannot create a draw: this loan has open post-closing conditions that must be cleared first.',
        });
        return;
      }
      drawActionsStore.setIsAddDrawDialogOpen(true);
    } catch {
      globalStore.notificationStore.showErrorNotification({
        message: 'Unable to verify post-closing conditions. Please try again.',
      });
    }
  };

  const buttons = [{
    label: 'Create Task',
    startIcon: <Add />,
    onClick: () => {
      editTaskStore.openAddTask(loanId);
    },
  }, {
    label: 'Add Draw',
    startIcon: <Add />,
    onClick: handleAddDraw,
  }, {
    label: `${!drawActionsStore.freezeFundingStatus ? 'Freeze' : 'Un-Freeze'} Funding`,
    onClick: () => {
      drawActionsStore.setIsFreezeFundingDialogOpen(true);
    }
  }];

  return (
    <Paper title='Actions' borderType={PaperBorderType.SOLID_BORDER}>
      <Grid container className={classes.buttonsContainer} direction='row' spacing={1}>
        {buttons.map(({ label, startIcon, onClick }) => (
          <Grid item key={label.replace(/\s+/g, '-').toLowerCase()}>
            <Button
              testId={label.replace(/\s+/g, '-').toLowerCase()}
              variant='outlined'
              className={classes.button}
              startIcon={startIcon}
              onClick={onClick}
            >
              {label}
            </Button>
          </Grid>
        ))
        }
      </Grid>
      <EditTaskDialog />
      <AddDrawV2 loanId={loanId} />
      <FreezeFunding loanId={loanId} />
    </Paper>
  );
});
